import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { SubmissionError } from 'redux-form';
import SubForm from 'components/SubForm';
import injectPreactivation from 'decorators/injectPreactivation';
import { sortByEffectiveDate } from '../../helpers/subs';
import getCarrier from '../../helpers/getCarrier';
import { fetchAllSimoDevices } from 'api';

const mapPreactivationToValues = (preactivation) => {
  if (!preactivation) {
    return {};
  }
  const { first_name, last_name, id } = preactivation;

  return {
    first_name,
    last_name,
    preactivation: id,
  };
};

let CreateSub = ({
  onSubmit,
  userId,
  submitSucceeded,
  saveStatus,
  user,
  sub,
  heading,
  redirectUrl,
  preactivationId,
  preactivation,
  isTrackfone,
  useUserName,
  carrierPrefix,
  initialSubs,
  fetchAllInitialsSubs,
  initialSubsLoading,
  isAttCreateSub,
  isSimo,
  device_sn,
  device_id,
  simoDevices,
  simoDevicesCount,
  simoDevicesLoading,
  coverageOptions,
  isQuick,
  quickVendors,
  quickSubTypes,
}) => {
  const handleChangeActivationType = (e) => {
    const value = e.target.value;
    const allCarriers = ['att', 'quick'];
    const isMdnChange = value === 'mdn_change';
    const isInternalMovement = value === 'internal_movement';

    if (isInternalMovement || isMdnChange) {
      const subStatus = isInternalMovement
        ? ['active', 'expired', 'suspended']
        : 'expired';
      let carriers;
      if (isQuick) {
        carriers = allCarriers;
      } else {
        carriers = isMdnChange
          ? allCarriers.filter((carrier) => carrier === carrierPrefix)
          : allCarriers.filter((carrier) => carrier !== carrierPrefix);
      }

      fetchAllInitialsSubs(
        {
          user_profile: userId,
        },
        {
          sort: sortByEffectiveDate,
          expiry_type: value,
          status: subStatus,
          carriers,
        },
      );
    }
  };

  const getInitialSub = (initialSubscription) => {
    if (!initialSubscription) {
      return {};
    }

    const sub = initialSubs.find(
      (sub) => sub.id === parseInt(initialSubscription, 10),
    );
    const carrier = getCarrier(sub);

    return {
      [`initial_${carrier}_subscription`]: initialSubscription,
    };
  };

  const handleSubmit = async ({
    initial_subscription,
    initial_subscription_manual,
    initial_subscription_manual_carrier,
    use_manual_initial_sub,
    ...values
  }) => {
    // need to replace device_sn with device id
    if (simoDevicesCount > 1000) {
      const invalidDeviceMsg = 'Incorrect device serial number';
      try {
        const response = await fetchAllSimoDevices({
          user_profile: userId,
          simo_status: 'active',
          serial_number: values.device,
        });
        const device = response?.data?.results?.[0];
        if (!device) {
          throw new SubmissionError({ device: invalidDeviceMsg });
        }

        // change device sn to id
        values.device = device.id;
      } catch (e) {
        if (e?.errors?.device) {
          throw e;
        }
        throw new SubmissionError({ device: 'Failed to find device' });
      }
    }

    if (isQuick) {
      values.subscription_type = 'mvno';
    }

    if (use_manual_initial_sub) {
      return onSubmit({
        ...values,
        user_profile: userId,
        [`initial_${initial_subscription_manual_carrier}_subscription`]:
          initial_subscription_manual,
      });
    }

    return onSubmit({
      ...values,
      user_profile: userId,
      ...getInitialSub(initial_subscription),
    });
  };

  if (submitSucceeded && sub) {
    return <Redirect to={redirectUrl(sub)} />;
  }

  if (preactivationId && !preactivation) {
    return null;
  }

  let initialValues = mapPreactivationToValues(preactivation);
  if (device_id && device_sn) {
    initialValues.device = device_id;
  }
  if (!isSimo) {
    initialValues.sms_notifications = true;
  }
  if (coverageOptions && coverageOptions.length) {
    initialValues.coverage = 'USA';
  }
  if (isAttCreateSub) {
    initialValues.bypass_att = true;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h1>{heading}</h1>
        {isSimo &&
          !simoDevices?.length &&
          !simoDevicesLoading &&
          !(device_id && device_sn) && (
            <Link to={`/users/${userId}/simo/new-device`}>
              <button className="btn btn-default mar-t">Add Simo Device</button>
            </Link>
          )}
      </div>
      <SubForm
        createSub={true}
        isTrackfone={isTrackfone}
        saveStatus={saveStatus}
        useUserName={useUserName}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        handleChangeActivationType={handleChangeActivationType}
        initialSubs={initialSubs}
        initialSubsLoading={initialSubsLoading}
        isAttCreateSub={isAttCreateSub}
        isSimo={isSimo}
        device_sn={device_sn}
        device_id={device_id}
        simoDevices={simoDevices}
        simoDevicesCount={simoDevicesCount}
        coverageOptions={coverageOptions}
        isQuick={isQuick}
        quickVendors={quickVendors}
        quickSubTypes={quickSubTypes}
      />
    </div>
  );
};

export default injectPreactivation(CreateSub);
